import { render } from "./CadastrarUser.vue?vue&type=template&id=264b418d"
import script from "./CadastrarUser.vue?vue&type=script&lang=js"
export * from "./CadastrarUser.vue?vue&type=script&lang=js"

import "./CadastrarUser.vue?vue&type=style&index=0&id=264b418d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__